// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"e1bd7fae","98":"0b32d45e","231":"07c63381","289":"55077998","465":"2bffd848","502":"30b125f2","524":"ad981e84","552":"9c063fb9","669":"2434674e","753":"a0fb053e","807":"3c63bb36","864":"9de42fe7","960":"f59d1c88"}[chunkId] + ".chunk.js";
};